module.exports = __webpack_public_path__ + "static/media/jakarta-pusat.b2738a55.svg";